<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <el-button>1231</el-button> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}
html,body,#app{
height: 100%;
width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue